import store from "../../store";
import {
  getSAMLSettingsService,
  getProfileInfoService,
  uploadProfilePictureService,
  getAccountSettingsService,
  updateAccountInfoService,
  updateAccountPictureService,
  updateAccountEmailService,
  addAccountAddressService,
  deleteAccountAddressService,
  updateAccountAddressService,
  updateSAMLSettingsService,
  uploadSAMLCertificateService,
  // Revv Oauth Serices
  createRevvOauthAppService,
  createRevvOauthClientService,
  deleteRevvOauthClientService,
  getRevvOauthAppsService,
  updateRevvOauthClientService,
  subscriptionCheckout,
  invokeStripe,
  stripePortalURL,
  stripeLastPayment,
} from "./settingsService";

import { addShowFieldToAddresses } from "./settingsMethods";
// import { OppoUtils } from "../../utils";

/*
==========================================
        Profile Settings Actions
==========================================
*/

export const getProfileInfo = () => dispatch =>
  new Promise((resolve, reject) => {
    getProfileInfoService()
      .then(response => {
        dispatch({
          type: "USER_PROFILE_SETTINGS",
          payload: response.UserProfile,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateProfilePicture = data => dispatch =>
  new Promise((resolve, reject) => {
    uploadProfilePictureService(data)
      .then(response => {
        dispatch({
          type: "USER_PROFILE_PICTURE",
          payload: response.URL,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

/*
==========================================
        Account Settings Actions
==========================================
*/

export const getAccountSettings = () => dispatch =>
  new Promise((resolve, reject) => {
    getAccountSettingsService()
      .then(response => {
        dispatch({
          type: "ACCOUNTS_SETTINGS",
          payload: addShowFieldToAddresses(response.Settings),
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateAccountInfo = info => dispatch =>
  new Promise((resolve, reject) => {
    updateAccountInfoService(info)
      .then(response => {
        console.debug(response);
        dispatch({
          type: "ACCOUNTS_SETTINGS",
          payload: addShowFieldToAddresses(response.Settings),
        });
        resolve("success");
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const updateAccountPicture = formData => dispatch =>
  new Promise((resolve, reject) => {
    updateAccountPictureService(formData)
      .then(response => {
        console.debug(response);
        const reduxState = store.getState();
        const { accountsSettings } = reduxState.SettingsStore;
        const { info } = accountsSettings;
        const infoWithNewPicture = { ...info, image_url: response.URL };
        dispatch({
          type: "ACCOUNTS_SETTINGS",
          payload: { ...accountsSettings, info: infoWithNewPicture },
        });
        resolve("success");
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const updateAccountEmail = email => dispatch =>
  new Promise((resolve, reject) => {
    updateAccountEmailService(email)
      .then(response => {
        console.debug(response);
        dispatch({
          type: "ACCOUNTS_SETTINGS",
          payload: addShowFieldToAddresses(response.Settings),
        });
        resolve("success");
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const addAccountAddress = address => dispatch =>
  new Promise((resolve, reject) => {
    addAccountAddressService(address)
      .then(response => {
        console.debug(response);
        const reduxState = store.getState();
        const { accountsSettings } = reduxState.SettingsStore;
        dispatch({
          type: "ACCOUNTS_SETTINGS",
          payload: {
            ...accountsSettings,
            addresses: [...accountsSettings.addresses, response.Address],
          },
        });
        resolve("success");
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const deleteAccountAddress = id => dispatch =>
  new Promise((resolve, reject) => {
    deleteAccountAddressService(id)
      .then(() => {
        const reduxState = store.getState();
        const { accountsSettings } = reduxState.SettingsStore;
        const addressArrayWithoutDeletedItem = accountsSettings.addresses.filter(
          address => address.id !== id,
        );
        dispatch({
          type: "ACCOUNTS_SETTINGS",
          payload: {
            ...accountsSettings,
            addresses: addressArrayWithoutDeletedItem,
          },
        });
        resolve("success");
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const updateAccountAddress = (id, address) => () =>
  new Promise((resolve, reject) => {
    updateAccountAddressService(id, address)
      .then(response => {
        console.debug(response);
        // const reduxState = store.getState();
        // const { accountsSettings } = reduxState.SettingsStore;
        // const addressArrayWithoutDeletedItem = accountsSettings.addresses.filter(
        //   address => address.id !== id,
        // );
        // dispatch({
        //   type: "ACCOUNTS_SETTINGS",
        //   payload: {
        //     ...accountsSettings,
        //     addresses: addressArrayWithoutDeletedItem,
        //   },
        // });
        resolve("success");
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

/*
==========================================
        Authentication Settings Actions
==========================================
*/
export const getSAMLSettings = () => dispatch =>
  new Promise((resolve, reject) => {
    getSAMLSettingsService()
      .then(response => {
        dispatch({
          type: "SAML_SETTINGS_INIT_DATA",
          payload: response.SAMLSettings,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`settingsActions => getSAMLSettings => ${error}`);
        reject(error);
      });
  });

export const uploadSAMLCertificate = formData => () =>
  new Promise((resolve, reject) => {
    uploadSAMLCertificateService(formData)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(`settingsActions => uploadSAMLCertificate => ${error}`);
        reject(error);
      });
  });

export const updateSAMLSettings = data => dispatch =>
  new Promise((resolve, reject) => {
    updateSAMLSettingsService(data)
      .then(response => {
        dispatch({
          type: "SAML_SETTINGS_INIT_DATA",
          payload: response.SAMLSettings,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`settingsActions => updateSAMLSettings => ${error}`);
        reject(error);
      });
  });
/*
==========================================
UI Actions for Accounts Edit mode - Non-Async
==========================================
*/

export const copyCompanyInfo = accountInfo => dispatch => {
  const { display_name: displayName, legal_name: legalName } = accountInfo;
  dispatch({
    type: "COMPANY_DISPLAY_NAME_INPUT",
    payload: displayName,
  });
  dispatch({
    type: "COMPANY_LEGAL_NAME_INPUT",
    payload: legalName,
  });
};

export const handleCompanyDisplayName = value => dispatch => {
  dispatch({
    type: "COMPANY_DISPLAY_NAME_INPUT",
    payload: value,
  });
};

export const handleCompanyLegalName = value => dispatch => {
  dispatch({
    type: "COMPANY_LEGAL_NAME_INPUT",
    payload: value,
  });
};

export const copyCompanyEmail = email => dispatch => {
  dispatch({
    type: "COMPANY_COMMUNICATION_EMAIL_INPUT",
    payload: email,
  });
};

export const handleCompanyEmail = value => dispatch => {
  dispatch({
    type: "COMPANY_COMMUNICATION_EMAIL_INPUT",
    payload: value,
  });
};

export const copyCompanyAddress = (addressID, addresses) => dispatch => {
  const addressToBeEdited = addresses.find(address => address.id === addressID);
  const { label, street, city, state, postalcode, country } = addressToBeEdited;
  dispatch({
    type: "COMPANY_ADDRESS_TYPE_INPUT",
    payload: label,
  });
  dispatch({
    type: "COMPANY_ADDRESS_STREET_INPUT",
    payload: street,
  });
  dispatch({
    type: "COMPANY_ADDRESS_CITY_INPUT",
    payload: city,
  });
  dispatch({
    type: "COMPANY_ADDRESS_STATE_INPUT",
    payload: state,
  });
  dispatch({
    type: "COMPANY_ADDRESS_PIN_CODE_INPUT",
    payload: postalcode,
  });
  dispatch({
    type: "COMPANY_ADDRESS_COUNTRY_INPUT",
    payload: country,
  });
};

export const handleCompanyAddressType = value => dispatch => {
  dispatch({
    type: "COMPANY_ADDRESS_TYPE_INPUT",
    payload: value,
  });
};

export const handleCompanyAddressStreet = value => dispatch => {
  dispatch({
    type: "COMPANY_ADDRESS_STREET_INPUT",
    payload: value,
  });
};

export const handleCompanyAddressCity = value => dispatch => {
  dispatch({
    type: "COMPANY_ADDRESS_CITY_INPUT",
    payload: value,
  });
};

export const handleCompanyAddressState = value => dispatch => {
  dispatch({
    type: "COMPANY_ADDRESS_STATE_INPUT",
    payload: value,
  });
};

export const handleCompanyAddressPinCode = value => dispatch => {
  dispatch({
    type: "COMPANY_ADDRESS_PIN_CODE_INPUT",
    payload: value,
  });
};

export const handleCompanyAddressCountry = value => dispatch => {
  dispatch({
    type: "COMPANY_ADDRESS_COUNTRY_INPUT",
    payload: value,
  });
};

export const discardAdressChanges = () => dispatch => {
  const reduxState = store.getState();
  const { accountsSettings } = reduxState.SettingsStore;
  dispatch({
    type: "ACCOUNTS_SETTINGS",
    payload: addShowFieldToAddresses(accountsSettings),
  });
  dispatch({
    type: "COMPANY_ADDRESS_TYPE_INPUT",
    payload: "",
  });
  dispatch({
    type: "COMPANY_ADDRESS_STREET_INPUT",
    payload: "",
  });
  dispatch({
    type: "COMPANY_ADDRESS_CITY_INPUT",
    payload: "",
  });
  dispatch({
    type: "COMPANY_ADDRESS_STATE_INPUT",
    payload: "",
  });
  dispatch({
    type: "COMPANY_ADDRESS_PIN_CODE_INPUT",
    payload: "",
  });
  dispatch({
    type: "COMPANY_ADDRESS_COUNTRY_INPUT",
    payload: "",
  });
};

export const removeEditAddressFromView = addressID => dispatch => {
  const reduxState = store.getState();
  const { accountsSettings } = reduxState.SettingsStore;
  const addressArrayWithEditItemHidden = accountsSettings.addresses.map(
    address => {
      if (address.id === addressID) {
        address.show = false;
      }
      return address;
    },
  );
  dispatch({
    type: "ACCOUNTS_SETTINGS",
    payload: {
      ...accountsSettings,
      addresses: addressArrayWithEditItemHidden,
    },
  });
};

/*
==========================================
     Revv Oauth Settings Actions
==========================================
*/

export const toggleRevvOauthView = ({
  fromPath,
  selectedAppID,
  selectedClientID,
  view,
}) => dispatch =>
  dispatch({
    type: "TOGGLE_REVV_OAUTH_VIEW",
    payload: {
      fromPath,
      selectedAppID,
      selectedClientID,
      view,
    },
  });

export const getRevvOauthApps = () => dispatch =>
  new Promise((resolve, reject) => {
    getRevvOauthAppsService()
      .then(response => {
        dispatch({
          type: "FETCH_REVV_OAUTH_APPS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`settingsActions => getRevvOauthApps => ${error}`);
        reject(error);
      });
  });

export const createRevvOauthApp = appName => dispatch =>
  new Promise((resolve, reject) => {
    createRevvOauthAppService(appName)
      .then(response => {
        dispatch({
          type: "ADD_REVV_OAUTH_APPS",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`settingsActions => createRevvOauthApp => ${error}`);
        reject(error);
      });
  });

export const createRevvOauthClient = (appID, payload) => dispatch =>
  new Promise((resolve, reject) => {
    createRevvOauthClientService(appID, payload)
      .then(response => {
        dispatch({
          type: "ADD_REVV_OAUTH_CLIENT",
          payload: {
            appID,
            data: response,
          },
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`settingsActions => createRevvOauthApp => ${error}`);
        reject(error);
      });
  });

export const updateRevvOauthClient = (appID, clientID, payload) => dispatch =>
  new Promise((resolve, reject) => {
    updateRevvOauthClientService(clientID, payload)
      .then(response => {
        dispatch({
          type: "UPDATE_REVV_OAUTH_CLIENT",
          payload: {
            appID,
            clientID,
            data: response,
          },
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`settingsActions => createRevvOauthApp => ${error}`);
        reject(error);
      });
  });

export const deleteRevvOauthClient = (appID, clientID) => dispatch =>
  new Promise((resolve, reject) => {
    deleteRevvOauthClientService(clientID)
      .then(response => {
        dispatch({
          type: "DELETE_REVV_OAUTH_CLIENT",
          payload: {
            appID,
            clientID,
          },
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`settingsActions => createRevvOauthApp => ${error}`);
        reject(error);
      });
  });

export const nukeRevvOauthData = () => dispatch =>
  dispatch({
    type: "NUKE_REVV_OAUTH_DATA",
  });

export const billingBandNotifyAction = notifyStatus => dispatch =>
  dispatch({
    type: "BILLING_BAND_NOTIFY_ACTION",
    payload: notifyStatus,
  });

export const getSubscriptionCheckoutSessionID = payload => () =>
  new Promise((resolve, reject) => {
    subscriptionCheckout(payload)
      .then(response => {
        // Get the stripe object
        const myStripePromise = invokeStripe();
        myStripePromise.redirectToCheckout({
          sessionId: response.session_id,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`updatePlan => updatePlan => ${error}`);
        reject(error);
      });
  });

export const getCustomerPortalURL = () => () =>
  new Promise((resolve, reject) => {
    stripePortalURL()
      .then(response => {
        // Get the stripe object
        window.location.replace(response.portal_url);
        resolve(response);
      })
      .catch(error => {
        console.error(`updatePlan => updatePlan => ${error}`);
        reject(error);
      });
  });

export const getLastBillingPayment = () => dispatch =>
  new Promise((resolve, reject) => {
    stripeLastPayment()
      .then(response => {
        dispatch({
          type: "BILLING_LAST_PAYMENT",
          payload: response.LastPaymentInfo,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`updatePlan => updatePlan => ${error}`);
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/SettingsActions/settingsActions.js